import { fetcher } from '@commenda/utils';
import {
  TCreateThresholdTriggerBody,
  TCreateThresholdTriggerResponse,
} from './types';

export async function createThresholdTrigger(
  body: TCreateThresholdTriggerBody
): Promise<TCreateThresholdTriggerResponse> {
  const response = await fetcher('tp-true-up/threshold-trigger', {
    method: 'POST',
    body,
  });
  if (!response.ok) throw new Error('Failed to create threshold trigger');
  return (await response.json()) as TCreateThresholdTriggerResponse;
}
